import { FC, useState, useCallback } from "react"
import { PickedMicroCopy } from "../Layout/Layout"

// components
import { SearchBar } from "./SearchBar/SearchBar"

export type HeaderSiteSearchMicroCopy = {
  messageSearchBar: PickedMicroCopy
  headerSearchResults: PickedMicroCopy
}

export type Props = {
  siteSearchMicroCopy: HeaderSiteSearchMicroCopy
  searchText?: string
  isResultsBoxShown?: boolean
}

const FALLBACK_MICROCOPY: Props["siteSearchMicroCopy"] = {
  messageSearchBar: {
    microcopyKey: "messageSearchBar",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Search help articles","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  headerSearchResults: {
    microcopyKey: "headerSearchResults",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Results for","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  }
}

export const HeaderSiteSearch: FC<Props> = ({
  siteSearchMicroCopy = FALLBACK_MICROCOPY,
  searchText,
  isResultsBoxShown = true
}) => {
  const [isSearchTakeoverOpen, setIsSearchTakeoverOpen] =
    useState<boolean>(false)
  const toggleTakeover = useCallback(() => {
    setIsSearchTakeoverOpen(!isSearchTakeoverOpen)
  }, [isSearchTakeoverOpen])

  return (
    <>
      <SearchBar
        placeholderText={searchText}
        isResultsBoxShown={isResultsBoxShown}
        takeover={{
          enabled: true,
          toggleTakeover
        }}
        isSearchTakeoverOpen={isSearchTakeoverOpen}
        messageSearchBarMicrocopy={siteSearchMicroCopy?.messageSearchBar}
        headerSearchResultsMicrocopy={siteSearchMicroCopy?.headerSearchResults}
        headerSearch={true}
      />
    </>
  )
}
